import { Alert } from '@atoms'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('imports.csv_box_not_set_up')

export const CsvBoxNotSetUpAlert = () => (
  <Alert type="warning" title={t('title')}>
    <p className="tw:text-sm">{t('body')}</p>
  </Alert>
)
